import { ArchivUser, AuthUser, Benutzer } from '@/models/AuthModels';
import { Configuration } from '@azure/msal-browser';

export type State = {
  authUser: AuthUser | null;

  azureLogin: boolean;
  azureLoginAvailable: boolean;
  azureUsername: string;
  msalConfig: Configuration | null;
  identityToken: String;

  archivUsers: Array<ArchivUser>;
  benutzer: Array<Benutzer>;
};

export const state: State = {
  authUser: localStorage.getItem('authUser') != null && localStorage.getItem('authUser') !== undefined ? JSON.parse(localStorage.authUser) : null,

  azureLogin: false,
  azureLoginAvailable: false,
  azureUsername: localStorage.getItem('azureusername') != null ? JSON.parse(localStorage.azureusername) : '',
  msalConfig: localStorage.getItem('msalconfig') != null ? JSON.parse(localStorage.msalconfig) : null,
  identityToken: '',

  archivUsers:
    sessionStorage.getItem('archivUsers') !== null && sessionStorage.getItem('archivUsers') !== undefined
      ? JSON.parse(sessionStorage.archivUsers)
      : new Array<ArchivUser>(),
  benutzer:
    sessionStorage.getItem('benutzer') !== null && sessionStorage.getItem('benutzer') !== undefined
      ? JSON.parse(sessionStorage.benutzer)
      : new Array<Benutzer>(),
};
